'use client';

import React from 'react';
import { Avatar, Chip, Link } from '@heroui/react';
import { RevshareCost } from '../types';
import { getCampaignTypeColors } from '../constants';

interface CampaignCellProps {
  cost: RevshareCost;
}

const CampaignCell: React.FC<CampaignCellProps> = ({ cost }) => {
  const { model, campaign_type } = cost;
  const typeColors = getCampaignTypeColors();
  const typeStyle = typeColors[campaign_type];

  return (
    <div className="flex items-center gap-4">
      <Avatar
        src={model.avatar}
        className="w-10 h-10 rounded-3"
        showFallback
        name={model.name?.slice(0, 1)}
        radius="lg"
      />
      <div className="flex flex-col gap-1">
        {/* Row 1: Name with icon and Type tag */}
        <div className="flex items-center gap-1">
          <Avatar
            src={cost.client.avatar}
            className="w-5 h-5 rounded-full"
            showFallback
            name={model.name?.slice(0, 1)}
            radius="lg"
          />
          <span className="text-auth-ink text-sm font-medium">{cost.client.name}</span>
          {/* <Chip
            size="sm"
            classNames={{
              base: `${typeStyle.bg} h-6 px-2`,
              content: `${typeStyle.text} text-xs font-normal p-0`,
            }}
          >
            {campaign_type}
          </Chip> */}
        </div>
        {/* Row 2: Campaign name and username */}
        <div className="flex items-center gap-2">
          <span className="text-auth-muted text-sm font-normal">
            {/* @ts-ignore */}
            {model?.of_user_id?.toString()?.slice(-4)}
          </span>
          <Link
            href={`https://onlyfans.com/${model.of_user_name}`}
            target="_blank"
            className="text-partner text-sm font-normal"
          >
            @{model.of_user_name}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CampaignCell;
